import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  alpha,
  Box,
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import EditPetDialog from "./EditPetDialog";
import PetDetails from "./PetDetails";

// Three-dots actions dialog of the pet header, same shape as the box view's PetActions
export default function PetHeaderActions({ pet = {} }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <IconButton
        title={t("Actions")}
        onClick={() => setOpen(true)}
        data-testid="pet.header.actions"
        sx={{
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            transform: "scale(1.05)",
          },
        }}
      >
        <MoreVertIcon />
      </IconButton>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{ sx: { borderRadius: 8 } }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
          }}
        >
          <Typography variant="h6" component="h2" fontWeight={600}>
            {t("Actions")}
          </Typography>
          <IconButton
            onClick={() => setOpen(false)}
            color="error"
            title={t("Close")}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ opacity: 0.6 }} />

        <DialogContent sx={{ p: 0 }}>
          <PetDetails pet={pet} />
          <EditPetDialog pet={pet} />
        </DialogContent>
      </Dialog>
    </>
  );
}
